import { ModuleWithProviders, NgModule } from "@angular/core";
// eslint-disable-next-line no-restricted-imports
import { NgxPermissionsModule, NgxPermissionsService } from "ngx-permissions";
import { FeatureFlagCheckDirective } from "./feature-flag-check.directive";
import { SharedNgxPermissionsService } from "./feature-flags.service";

@NgModule({
    imports: [NgxPermissionsModule.forRoot()],
    declarations: [FeatureFlagCheckDirective],
    exports: [FeatureFlagCheckDirective],
})
export class FeatureFlagsModule {
    public static forRoot(): ModuleWithProviders<FeatureFlagsModule> {
        return {
            ngModule: FeatureFlagsModule,
            providers: [{ provide: NgxPermissionsService, useExisting: SharedNgxPermissionsService }],
        };
    }
}
